module.exports = __webpack_public_path__ + "static/media/importICS2.a6b407b0.png";